var _path, _circle, _circle2, _path2, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Svg403(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "auto",
    viewBox: "0 0 714 364",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M221.924 261.275V218.298H184.046V63.8717H119.216L9.58756 221.576V261.275H126.136V317H184.046V261.275H221.924ZM128.321 145.456V218.298H60.9417C66.0406 212.835 70.4112 207.008 77.6955 196.445L113.753 143.27C120.673 132.708 125.043 125.788 128.321 117.411H129.05C128.321 126.516 128.321 132.344 128.321 145.456Z",
    fill: "#DBE9F5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 363.895,
    cy: 235.047,
    r: 96.8242,
    stroke: "#DBE9F5",
    strokeWidth: 33.4453
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 363.909,
    cy: 235.059,
    r: 22.1625,
    fill: "#DBE9F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M602.193 322.463C662.288 322.463 700.895 292.962 700.895 246.343C700.895 212.107 680.863 191.346 643.713 185.883C673.943 178.963 694.339 156.382 694.339 127.973C694.339 83.9034 661.195 58.4085 602.921 58.4085C543.19 58.4085 504.948 90.0951 504.948 139.628L562.858 147.277C562.858 119.232 576.334 102.843 600.008 102.843C621.496 102.843 633.879 114.497 633.879 134.893C633.879 156.382 620.768 168.401 594.909 168.401H581.797V208.464H595.637C625.138 208.464 639.343 220.119 639.343 242.336C639.343 264.553 626.595 277.301 602.557 277.301C577.791 277.301 562.129 261.275 561.765 234.688L502.398 240.151C503.127 290.777 541.369 322.463 602.193 322.463Z",
    fill: "#DBE9F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13515_189473)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 364.908,
    cy: 140.481,
    r: 57.6898,
    stroke: "#DBE9F5",
    strokeWidth: 26.4567
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13515_189473"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 204,
    height: 86,
    fill: "white",
    transform: "translate(262.071 68.2188)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(Svg403);
export default __webpack_public_path__ + "static/media/403.7e5345bdc4679f9bf23884f413c0122a.svg";
export { ForwardRef as ReactComponent };